'use client';

import * as React from 'react';
import { motion, useAnimation, Variants } from 'framer-motion';

const pathVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
		pathOffset: 0,
	},
	animate: {
		opacity: [0, 1],
		pathLength: [0, 1],
		transition: {
			delay: 0.1,
			duration: 0.4,
			opacity: { duration: 0.1, delay: 0.1 },
		},
	},
};

export function ChartPieIcon({ isHovered }: { isHovered: boolean }) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				className={`transition-transform duration-200 ${
					isHovered ? 'scale-110' : ''
				}`}
			>
				<motion.path
					variants={pathVariants}
					initial='normal'
					animate={controls}
					d='M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z'
				/>
				<path d='M21.21 15.89A10 10 0 1 1 8 2.83' />
			</svg>
		</div>
	);
}
